<template>
    <img src="@images/portal/mailing-list-empty.svg" alt="" />
</template>
<script>
export default {
    name: "MailingListsEmptyInboxIcon"
}
</script>
